import { render, staticRenderFns } from "./CardDetalhesComprador.vue?vue&type=template&id=50d49e8d&scoped=true&"
import script from "./CardDetalhesComprador.vue?vue&type=script&lang=js&"
export * from "./CardDetalhesComprador.vue?vue&type=script&lang=js&"
import style0 from "./CardDetalhesComprador.vue?vue&type=style&index=0&id=50d49e8d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d49e8d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCardText,VDivider,VSubheader})
